<section class="assign-staff-dialog" aria-labelledby="assign-staff-title">
    <header class="dialog-header">
        <div>
            <h2 id="assign-staff-title">Assign to staff</h2>
        </div>
        <button type="button" class="dialog-close" aria-label="Close dialog" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </header>

    <div class="staff-list" role="region" aria-label="Staff members" tabindex="0">
        <table class="staff-table">
            <thead>
                <tr>
                    <th scope="col" class="number-column">S.NO</th>
                    <th scope="col" class="name-column">NAME</th>
                    <th scope="col" class="email-column">EMAIL ID</th>
                    <th scope="col" class="action-column">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let records of allStaffRecords; let rowIndex = index">
                    <td class="number-column">{{rowIndex + 1}}</td>
                    <td class="name-cell">{{records.personalDetails.firstName}}</td>
                    <td class="email-cell">{{records.personalDetails.email}}</td>
                    <td class="action-column">
                        <button type="button" class="assign-button" (click)="assign(records)">
                            <span class="assign-icon" aria-hidden="true">+</span>
                            Assign
                        </button>
                    </td>
                </tr>
                <tr *ngIf="allStaffRecords.length === 0">
                    <td colspan="4" class="empty-state">No staff members available.</td>
                </tr>
            </tbody>
        </table>
    </div>
</section>